<template>
  <v-navigation-drawer
    v-model="formShow"
    clipped
    right
    fixed
    width="30rem"
    style="top: 100px"
    stateless
  >
    <v-form
      ref="form"
      lazy-validation
      class="d-flex flex-column"
      style="height: calc(100% - 100px)"
    >
      <v-toolbar flat dark color="primary">
        <v-list-item class="px-0" v-if="formAction === 'add'">
          <v-list-item-icon>
            <v-icon>mdi-plus</v-icon>
          </v-list-item-icon>
          <v-list-item-title>เพิ่มกลุ่ม Device ใหม่</v-list-item-title>
        </v-list-item>
        <v-list-item class="px-0" two-line v-else>
          <v-list-item-content>
            <v-list-item-title>
              {{ taHardwareGroupInit.title_th }}
            </v-list-item-title>
            <v-list-item-subtitle> Hardware Group </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-spacer></v-spacer>

        <v-btn icon @click="onClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <div style="height: 100%; overflow: auto">
        <tabs class="mt-2" @selectedTab="handleSelectedTab">
          <tab
            title="ข้อมูลทั่วไป"
            class="px-4"
            style="background-color: white"
          >
            <div>
              <label class="body-2">
                คำอธิบาย (ไทย)
                <span class="red--text"><strong>*</strong></span>
              </label>
              <v-text-field
                class="fix-google-chrome mt-1"
                v-model="taHardwareGroup.title_th"
                :rules="[(v) => !!v || 'โปรดระบุคำอธิบาย']"
                outlined
                dense
                required
                clearable
                @change="checkEmpty($event, 'title_th')"
              >
              </v-text-field>
            </div>
            <div>
              <label class="body-2"> คำอธิบาย (อังกฤษ) </label>
              <v-text-field
                class="fix-google-chrome mt-1"
                v-model="taHardwareGroup.title_en"
                outlined
                dense
                clearable
                @change="checkEmpty($event, 'title_en')"
              >
              </v-text-field>
            </div>
          </tab>
          <tab
            title="Device ในกลุ่ม"
            class="pt-0 px-4"
            style="background-color: white"
          >
            <div v-if="formAction === 'add' && !isShowTaHardwareGroupAdd">
              กรุณาเพิ่มข้อมูลทั่วไปก่อน
            </div>
            <div v-else>
              <v-row>
                <v-col class="py-0" cols="12" lg="6">
                  <label class="caption"> ค้นหา </label>
                  <v-text-field
                    v-model="search"
                    class="fix-google-chrome"
                    prepend-inner-icon="mdi-magnify"
                    outlined
                    dense
                    clearable
                    @input="handleSearchTaHardware"
                    hide-details
                  >
                  </v-text-field
                ></v-col>
                <v-col class="py-0" cols="12" lg="6">
                  <label class="caption"> รุ่นของ Device </label>
                  <v-autocomplete
                    v-model="taHardwareModelFilter"
                    class="fix-google-chrome"
                    :items="taHardwareModels"
                    item-text="title"
                    item-value="hardware_model_code"
                    hide-details
                    outlined
                    dense
                    clearable
                    @change="handleFilterTaHardwareModel"
                  >
                  </v-autocomplete
                ></v-col>
              </v-row>
              <div class="d-lg-flex justify-space-between align-baseline mb-4">
                <div>
                  <button type="button" @click="$emit('onClickAddTaHardware')">
                    <v-icon left small color="primary">mdi-plus</v-icon>
                    <span class="caption primary--text"
                      >เพิ่ม Device ในกลุ่ม</span
                    >
                  </button>
                </div>
                <div style="width: 200px">
                  <v-select
                    style="font-size: 14px"
                    v-model="sort"
                    :disabled="pagination.isLoading"
                    prepend-inner-icon="mdi-sort-ascending"
                    :items="sorts"
                    hide-details
                    @change="handleChangeSort"
                  ></v-select>
                </div>
              </div>
            </div>
            <DynamicScroller
              :items="taHardwaresGroupMember"
              :min-item-size="pagination.limit"
              key-field="hardware_uuid"
            >
              <template v-slot="{ item, index, active }">
                <DynamicScrollerItem
                  :item="item"
                  :active="active"
                  :data-index="index"
                >
                  <v-card
                    color="#f5f5f5"
                    outlined
                    class="d-flex align-center mb-2"
                    v-observe-visibility="
                      item.hardware_uuid === lastHardware.hardware_uuid &&
                      !isLastPage
                        ? infiniteScrollHandler
                        : false
                    "
                  >
                    <v-list-item two-line>
                      <v-list-item-content>
                        <v-list-item-title>
                          <span
                            class="d-inline-block text-truncate"
                            style="max-width: 360px"
                          >
                            {{ item.hardware_code }} - {{ item.title_th }}
                          </span>
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          <span
                            class="d-inline-block text-truncate"
                            style="max-width: 360px"
                          >
                            รุ่น : {{ item.hardware_model.title }}
                          </span>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <div class="px-2">
                      <v-btn
                        icon
                        @click="handleDeleteTaHardwareGroupMember(item)"
                      >
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </v-card>
                </DynamicScrollerItem>
              </template>
            </DynamicScroller>
            <div v-if="pagination.isLoading">
              <v-card
                color="#f5f5f5"
                v-for="num in 2"
                :key="num"
                outlined
                class="mb-2 px-4 py-2"
              >
                <Skeleton width="200px" />
                <Skeleton :count="1" />
              </v-card>
            </div>
          </tab>
        </tabs>
      </div>
      <v-toolbar flat color="blue-grey lighten-4" v-if="selectedTab === 0">
        <v-row
          justify="center"
          align="center"
          v-if="
            (!isTaHardwareGroupDataChange && formAction === 'edit') ||
            (formAction === 'add' && isShowTaHardwareGroupAdd)
          "
        >
          <v-btn icon @click="onDelete">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-row>
        <v-row justify="center" align="center" v-else>
          <v-btn
            class="primary mr-3"
            depressed
            v-if="formAction === 'add'"
            @click="onSubmit"
            >ตกลง
          </v-btn>
          <v-btn class="primary mr-3" depressed v-else @click="onSave"
            >บันทึก
          </v-btn>
          <v-btn depressed @click="onReset">ยกเลิก</v-btn>
        </v-row>
      </v-toolbar>
    </v-form>
    <ConfirmDialog
      :dialog="confirmDialogDelete"
      :loading="confirmDialogDeleteLoading"
      :dialogData="confirmDialogDeleteData"
      @cancelConfirmDialog="cancelConfirmDialogDelete"
      @submitConfirmDialog="submitConfirmDialogDelete"
    />
    <ConfirmDialog
      :dialog="confirmDialogDeleteMember"
      :loading="confirmDialogDeleteLoadingMember"
      :dialogData="confirmDialogDeleteDataMember"
      @cancelConfirmDialog="cancelConfirmDialogDeleteMember"
      @submitConfirmDialog="submitConfirmDialogDeleteMember"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
  </v-navigation-drawer>
</template>

<script>
import Tab from '@/components/Tab.vue'
import Tabs from '@/components/Tabs.vue'
import _ from 'lodash'
import { Skeleton } from 'vue-loading-skeleton'
import { DynamicScroller, DynamicScrollerItem } from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'

export default {
  components: {
    ConfirmDialog,
    DynamicScroller,
    DynamicScrollerItem,
    Skeleton,
    Tab,
    Tabs,
  },
  props: {
    formShow: {
      type: Boolean,
      default: false,
    },
    formAction: {
      type: String,
      default: '',
    },
    taHardwareGroup: {
      type: Object,
    },
    taHardwareGroupInit: {
      type: Object,
    },
  },
  watch: {
    taHardwareGroup(item) {
      if (item.hardware_group_uuid) {
        this.taHardwaresGroupMember = []
        this.pagination.currentPage = 1
        this.getTaHardwaresGroupMember()
      }
    },
  },
  data() {
    return {
      selectedTab: 0,
      isShowTaHardwareGroupAdd: false,
      taHardwareModelFilter: '',
      search: '',
      pagination: {
        currentPage: 1,
        limit: 10,
        isLoading: false,
      },
      taHardwaresGroupMember: [],
      totalTaHardwaresGroupMember: 0,
      sort: 'hardware_code,asc',
      sorts: [
        { id: 1, text: 'เรียงตามรหัส', value: 'hardware_code,asc' },
        { id: 2, text: 'เรียงตามชื่อ (a - z)', value: 'title_th,asc' },
      ],
      confirmDialogDelete: false,
      confirmDialogDeleteLoading: false,
      confirmDialogDeleteData: {},
      confirmDialogDeleteMember: false,
      confirmDialogDeleteLoadingMember: false,
      confirmDialogDeleteDataMember: {},
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
    }
  },
  computed: {
    lastHardware() {
      const [lastItem] = this.taHardwaresGroupMember.slice(-1)
      return lastItem || {}
    },
    isLastPage() {
      return (
        this.pagination.currentPage ===
        Math.ceil(this.totalTaHardwaresGroupMember / this.pagination.limit)
      )
    },
    taHardwareModels() {
      return this.$store.state.hardware.hardwareModels.filter(
        (h) => !['q2', 'q3', 'acu81', 'acu81r'].includes(h.hardware_model_code)
      )
    },
    isTaHardwareGroupDataChange() {
      if (
        this.taHardwareGroup.title_th !== this.taHardwareGroupInit.title_th ||
        this.taHardwareGroup.title_en !== this.taHardwareGroupInit.title_en
      ) {
        this.$emit('isTaHardwareGroupDataChange', true)
        return true
      }
      this.$emit('isTaHardwareGroupDataChange', false)
      return false
    },
  },
  methods: {
    ...mapActions({
      fetchTaHardwaresGroupMember:
        'taHardwaresGroup/fetchTaHardwaresGroupMember',
      deleteTaHardwareGroupMember:
        'taHardwaresGroup/deleteTaHardwareGroupMember',
      addTaHardwareGroup: 'taHardwaresGroup/addTaHardwareGroup',
      editTaHardwareGroup: 'taHardwaresGroup/editTaHardwareGroup',
      deleteTaHardwareGroup: 'taHardwaresGroup/deleteTaHardwareGroup',
    }),
    handleSelectedTab(i) {
      this.selectedTab = i
    },
    handleDeleteTaHardwareGroupMember(item) {
      this.confirmDialogDeleteMember = true
      this.confirmDialogDeleteDataMember = {
        title: 'ยืนยันการลบ',
        text: 'คุณต้องการลบ Device',
        value: `${item.title_th}`,
        item,
      }
    },
    cancelConfirmDialogDeleteMember() {
      this.confirmDialogDeleteMember = false
    },
    async submitConfirmDialogDeleteMember({ hardware_uuid }) {
      try {
        this.search = ''
        this.confirmDialogDeleteLoadingMember = true

        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
          hardware_group_uuid: this.taHardwareGroup.hardware_group_uuid,
          hardware_uuid,
        }

        await this.deleteTaHardwareGroupMember(payload)
        this.confirmDialogDeleteLoadingMember = false
        this.confirmDialogDeleteMember = false

        const snackbar = {
          show: true,
          color: 'success',
          timeout: 2000,
          message: 'ลบข้อมูลสำเร็จ',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)

        this.taHardwaresGroupMember = []
        this.pagination.currentPage = 1
        await this.getTaHardwaresGroupMember()
        this.$store.commit('taHardwaresGroup/EDIT_TA_HARDWARE_GROUP', {
          ...this.taHardwareGroup,
          hardware_group_member: {
            ...this.taHardwareGroup.hardware_group_member,
            total: this.totalTaHardwaresGroupMember,
          },
        })
      } catch (error) {
        this.confirmDialogDeleteLoadingMember = false

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
    handleFilterTaHardwareModel() {
      this.taHardwaresGroupMember = []
      this.pagination.currentPage = 1
      this.getTaHardwaresGroupMember()
    },
    handleSearchTaHardware: _.debounce(function () {
      if (this.search === undefined || this.search === null) return
      this.taHardwaresGroupMember = []
      this.pagination.currentPage = 1
      this.getTaHardwaresGroupMember()
    }, 1000),
    handleChangeSort() {
      this.taHardwaresGroupMember = []
      this.pagination.currentPage = 1
      this.getTaHardwaresGroupMember()
    },
    async getTaHardwaresGroupMember() {
      try {
        this.pagination.isLoading = true

        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
          hardware_group_uuid: this.taHardwareGroup.hardware_group_uuid,
          query: {
            hardware_model_code: this.taHardwareModelFilter || undefined,
            search: this.search || undefined,
            sort: this.sort,
            limit: `${this.pagination.limit},${
              (this.pagination.currentPage - 1) * this.pagination.limit
            }`,
          },
        }
        const {
          total: totalTaHardwaresGroupMember,
          data: taHardwaresGroupMember,
        } = await this.fetchTaHardwaresGroupMember(payload)
        this.totalTaHardwaresGroupMember = totalTaHardwaresGroupMember
        this.setTaHardwaresGroupMember(taHardwaresGroupMember)
        this.pagination.isLoading = false
      } catch (error) {
        this.pagination.isLoading = false

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
    async getNextTaHardwaresGroupMember() {
      try {
        this.pagination.currentPage += 1

        await this.getTaHardwaresGroupMember()
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
    setTaHardwaresGroupMember(taHardwaresGroupMember) {
      this.taHardwaresGroupMember = [
        ...this.taHardwaresGroupMember,
        ...taHardwaresGroupMember,
      ]
    },
    infiniteScrollHandler(isVisible, entry) {
      if (isVisible && entry.isIntersecting) {
        this.getNextTaHardwaresGroupMember()
      }
    },
    checkEmpty(value, field) {
      if (value) {
        this.taHardwareGroup[field] = value.trim()
      }
    },
    onDelete() {
      this.confirmDialogDelete = true
      this.confirmDialogDeleteData = {
        title: 'ยืนยันการลบ',
        text: 'คุณต้องการลบกลุ่ม Device',
        value: this.taHardwareGroup.title_th,
        item: this.taHardwareGroup,
      }
    },
    cancelConfirmDialogDelete() {
      this.confirmDialogDelete = false
    },
    submitConfirmDialogDelete({ hardware_group_uuid }) {
      this.confirmDialogDeleteLoading = true

      const { company_uuid } = this.$store.state.authentication.company

      const payload = {
        company_uuid,
        hardware_group_uuid,
      }

      this.deleteTaHardwareGroup(payload)
        .then(() => {
          this.confirmDialogDeleteLoading = false
          this.confirmDialogDelete = false

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'ลบข้อมูลสำเร็จ',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)

          this.$emit('formActionCompleted', this.formAction)
          this.$refs.form.reset()
          this.sort = 'hardware_code,asc'
          this.taHardwaresGroupMember = []
          this.isShowTaHardwareGroupAdd = false
        })
        .catch((error) => {
          this.confirmDialogDeleteLoading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    async onSubmit() {
      if (this.$refs.form.validate()) {
        try {
          this.$store.state.loading = true

          const { company_uuid } = this.$store.state.authentication.company

          const payload = {
            company_uuid,
            body: {
              title_th: this.taHardwareGroup.title_th,
              title_en: this.taHardwareGroup.title_en || undefined,
            },
          }

          const taHardwareGroup = await this.addTaHardwareGroup(payload)
          this.$emit('addTaHardwareGroupSuccess', taHardwareGroup)
          this.$store.state.loading = false

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'เพิ่มข้อมูลสำเร็จ',
          }

          this.$store.commit('SET_SNACKBAR', snackbar)

          this.isShowTaHardwareGroupAdd = true
        } catch (error) {
          this.$store.state.loading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        }
      }
    },
    async onSave() {
      if (this.$refs.form.validate()) {
        try {
          this.$store.state.loading = true

          const { company_uuid } = this.$store.state.authentication.company

          const payload = {
            company_uuid,
            hardware_group_uuid: this.taHardwareGroup.hardware_group_uuid,
            body: {
              title_th: this.taHardwareGroup.title_th,
              title_en: this.taHardwareGroup.title_en || undefined,
            },
          }

          await this.editTaHardwareGroup(payload)
          this.$store.state.loading = false

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'แก้ไขข้อมูลสำเร็จ',
          }

          this.$store.commit('SET_SNACKBAR', snackbar)

          this.$emit('formActionCompleted', this.formAction)
          this.$refs.form.reset()
          this.sort = 'hardware_code,asc'
          this.taHardwaresGroupMember = []
        } catch (error) {
          this.$store.state.loading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        }
      }
    },
    onClose() {
      if (this.isTaHardwareGroupDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
        }
        this.confirmDialogDataChange = true
      } else {
        this.$emit('formActionCompleted', this.formAction)
        this.$refs.form.reset()
        this.sort = 'hardware_code,asc'
        this.taHardwaresGroupMember = []
        this.isShowTaHardwareGroupAdd = false
      }
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange() {
      this.confirmDialogDataChange = false

      this.$emit('formActionCompleted', this.formAction)
      this.$refs.form.reset()
      this.sort = 'hardware_code,asc'
      this.taHardwaresGroupMember = []
      this.isShowTaHardwareGroupAdd = false
    },
    onReset() {
      this.$emit('formActionCompleted', this.formAction)
      this.$refs.form.reset()
      this.sort = 'hardware_code,asc'
      this.isShowTaHardwareGroupAdd = false
    },
  },
}
</script>
